export default "__VITE_PUBLIC_ASSET__84487531__"